/**
 * Created by lari on 12/06/2017.
 */
(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name log.factory:ClientlogService
   *
   * @description
   *
   */
  angular
    .module('vcreminder')
    .factory('Clientlog', Clientlog)
    .config(config);


  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }


  Clientlog.$inject = ['restmod'];

  function Clientlog(restmod) {
    return restmod.model('/routes/clientlogs').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/clientlogs/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            let realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          }
        } // Model
      }// extend
    });
  }


  // Klammerfriedhof
}());
